__webpack_require__.p = "/frontendMentor-single-price-grid/";